import yup from './yup'
import moment from 'moment/moment'

export const sessionFromSchema = yup.object().shape({
  startDate: yup.date().label('Start Date').required().typeError('Invalid date'),
  endDate: yup
    .date()
    .label('End date')
    .typeError('Invalid date')
    .test(
      'Date Check',
      { errType: 'Date', msg: 'End date must be after start date.' },
      function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate, 'date')
      }
    )
    .test(
      'Time Check',
      { errType: 'Time', msg: 'End Time must be after start Time.' },
      function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate)
      }
    )
    .required(),
  title: yup.string().label('Title').trimmedRequired('Session Title is required'),
  moderators: yup.array().label('Moderators'),
  venueId: yup.string().label('Venue').required(),
  havePolls: yup.string().oneOf(['yes', 'no']),
  speakerId: yup.mixed().when('havePolls', {
    is: 'yes',
    then: yup.string().label('Speaker').nullable().required()
  }),
  pollId: yup.mixed().when('havePolls', {
    is: 'yes',
    then: yup.string().label('Associated Poll').nullable().required()
  }),
  keynotes: yup.string().label('Keynotes'),
  cardColor: yup.string().label('Card Color')
})
